/**
 * See IssbQuestionDTO.java
 */
export default class Question {
  id;
  reference;
  title;
  status;
  owner;
  // TODO: add other fields
}

/**
 * @param {Question} question
 * @returns {boolean} true if the question is excluded by rule / not-applicable or manually excluded, HACK checks both stageType and relevance.
 * false for null/undefined question or stageType/relevance
 */
export function isExcludedFn(question) {
  if (!question) return false; // since we only return true for definite cases, we return false for null/undefined
  const stageType = question.stageType;
  if (stageType === "EXCLUDED" || stageType === "EXCLUDED_BY_RULE") {
    return true;
  }
  const relevance = question.relevance;
  if (relevance === "EXCLUDED" || relevance === "NOT_APPLICABLE") {
    return true;
  }
  return false;
}
